import * as R from 'ramda'
import { useMemo } from 'react'
import { useRoomsWithSendMessagePermission } from '$logic/room-list/room-list.react-hook'
import { useRecentSearchedRooms } from '$logic/room-list/room-list-search.react-hook'

export function useForwardableRecentSearchedRooms() {
  const recentRooms = useRecentSearchedRooms()
  const { items, loadingItems } = useRoomsWithSendMessagePermission()

  return useMemo(() => {
    const itemIds = R.pluck('chatId', items)
    return loadingItems
      ? []
      : recentRooms.filter(room => itemIds.includes(room.id))
  }, [recentRooms.join(''), items.join(''), loadingItems])
}
